exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graph[data-v-7f42f749]{height:250px;padding:30px 0 5px;position:relative}.graph.minimalMargin[data-v-7f42f749]{margin-left:-15px;margin-right:-15px}@media (min-width:700px){.graph[data-v-7f42f749]{height:300px;padding:30px 0 10px}}@media (min-width:900px){.graph[data-v-7f42f749]{height:350px;padding:30px 0 15px}}@media (min-width:1100px){.graph[data-v-7f42f749]{height:450px;padding:30px 0 15px}}", ""]);

// exports
